module.exports = __webpack_public_path__ + "img/league-of-legends.e916425e.png";